module.exports = __webpack_public_path__ + "fonts/iconfont.111f9aa4.ttf";